<div class="view-container">
  <mat-card>
    <mat-card-content>
      <div class="container" fxLayout="row" fxLayoutAlign="start center">
        
        <div class="save-info" fxFlex="20" fxLayout="column" fxLayoutAlign="start start">
          <div>
            Autosave: On
          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div *ngIf="debouncingSave">Changes Found</div>
            <div *ngIf="saving">Saving</div>
            <div *ngIf="!debouncingSave && !loading">Theme Saved <span *ngIf="lastSave" [matTooltip]="lastSave?.toString()" style="font-size: 0.65rem;">({{ timeAgoString(lastSave) }})</span></div>
            <mat-spinner *ngIf="saving" [diameter]="14"></mat-spinner>
          </div>
        </div>

        <div class="toolbar" fxFlex="60" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">

          <mat-form-field class="accent">
            <mat-label>Filter Line Items</mat-label>
            <input matInput type="text" name="themeLineItemFilterTerm"
                [(ngModel)]="themeLineItemFilterTerm"
                (ngModelChange)="filterThemeLineItems()">
            <button mat-button *ngIf="themeLineItemFilterTerm" matSuffix mat-icon-button aria-label="Clear" (click)="themeLineItemFilterTerm=''; filterThemeLineItems()">
                <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
      
          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button color="accent" [disabled]="hasSelectedAllLineItemGroups()" (click)="selectAllLineItemGroups()" matTooltip="Select All">
              <mat-icon>select_all</mat-icon>
            </button>
            <button mat-icon-button color="accent" [disabled]="!hasSelectedLineItemGroups()" (click)="deselectAllLineItemGroups()" matTooltip="Deselect All">
              <mat-icon>deselect</mat-icon>
            </button>
          </div>

          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button color="accent" [disabled]="!hasSelectedLineItemGroups()" (click)="deleteSelectedLineItemGroups()" matTooltip="Delete Selected">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
      
          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button color="accent" [disabled]="!hasSelectedLineItemGroups()" (click)="copyLineItemGroups()" matTooltip="Copy Selected">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button mat-icon-button color="accent" (click)="pasteLineItemGroups()" matTooltip="Paste">
              <mat-icon>content_paste</mat-icon>
            </button>
          </div>
        
          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button color="accent" [disabled]="undoStack.length <= 0" (click)="handleUndo()" matTooltip="Undo">
              <mat-icon>undo</mat-icon>
            </button>
            <button mat-icon-button color="accent" [disabled]="redoStack.length <= 0" (click)="handleRedo()" matTooltip="Redo">
              <mat-icon>redo</mat-icon>
            </button>
          </div>

        </div>

        <div fxFlex="20" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          <div *ngIf="theme && isSituUser">
            <button mat-icon-button [color]="isInteractiveThemeEditorOpen() ? 'warn' : 'accent'" (click)="openinteractiveThemeEditor()" matTooltip="Open Interactive Theme Editor">
              <mat-icon>panorama</mat-icon>
            </button>
          </div>
          <div *ngIf="theme && isSituUser">
            <a [routerLink]="['/reports/theme-product-progress']"
              [queryParams]="{
                xAxisType: 'Supplier',
                yAxisType: 'ProductStatus',
                subjectName: theme?.name,
                themeIdFilter: theme?.id,
                themeIsInReleaseFilter: true
              }"
              routerLinkActive="active">
              <mat-icon class="link" color="basic" matTooltip="Open Progress Report">stacked_bar_chart</mat-icon>
            </a>
          </div>
          <div *ngIf="theme" fxLayout="column" fxLayoutAlign="space-between center">
            <button class="m-t-15" mat-flat-button color="primary" (click)="publishTheme()" [disabled]="publishing">
              Publish Theme
            </button>

            <div *ngIf="publishing" class="m-t-10" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
              <mat-progress-spinner diameter="18" mode="indeterminate" color="primary"></mat-progress-spinner>
              <small class="text-muted">
                {{ publishQueuePosition ? 'Publishing… (queue position ' + publishQueuePosition + ')' : 'Publishing…' }}
              </small>
            </div>

            <div [matTooltip]="theme.dateLastPublished" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="5px">
              <small class="text-muted">Last Published </small>
              <small>{{ timeAgoString(publishedLastDate) }}</small>
            </div>
          </div>
          
        </div>

      </div>
    </mat-card-content>
  </mat-card>  
  <mat-card *ngIf="loading">
    <mat-card-content>
      Loading...
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="!loading">
    <mat-card-content class="custom-mat-card-expansion" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="w-100" fxLayout="row">
        <mat-card class="contrast card-link banner-incomplete w-100 m-5 m-l-0" (click)="addProduct(undefined, undefined, true)">
          <mat-card-content class="h-100" fxLayout="row" fxLayoutAlign="space-between center">
            <span>Add a product</span>
          </mat-card-content>
        </mat-card>
        
        <mat-card class="contrast card-link banner-incomplete w-100 m-5" (click)="addTag()">
          <mat-card-content class="h-100" fxLayout="row" fxLayoutAlign="space-between center">
            <span>Add a tag</span>
            
            <button mat-flat-button (click)="showAutoFillTagOptions = !showAutoFillTagOptions; $event.stopPropagation();">
              Auto Fill Tags
            </button>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-accordion class="w-100 m-b-5 theme-configuration" *ngIf="theme">
        <mat-expansion-panel #themeConfigPanel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>Theme Configuration</mat-panel-title>
            <mat-panel-description class="theme-configuration-toggle">
              <mat-icon>{{ themeConfigPanel.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="theme-configuration-body" fxLayout="column" fxLayoutGap="15px">
            <mat-checkbox
              [(ngModel)]="theme.isFloorPlanTheme"
              (ngModelChange)="saveThemeConfiguration()"
              matTooltip="When enabled, this theme is reserved as the home's floor plan theme. instead of being placed as regular 3D furniture, its items are swapped in only when the 2D floor plan is rendered.">
              Set as Floor Plan Theme
            </mat-checkbox>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div *ngIf="showAutoFillTagOptions" class="w-100 m-10 m-t-0">
        Auto Fill Tag Options:
        <form [formGroup]="autoFillTagSearchForm" (ngSubmit)="autoFillTags()" fxLayout="column"fxLayoutAlign="start start" fxLayoutGap="10px">
          
          <div fxLayout="column">
            <div fxLayout="row" fxLayoutGap="10px">
              <mat-checkbox formControlName="filterByHomesInRelease" matTooltip="Only return IFC tags from homes that are used in the same releases as the selected theme.">
                Filter IFC tags by release
              </mat-checkbox>
              <mat-checkbox formControlName="filterActiveReleases" matTooltip="Only return tags for releases that are currently active.">
                Filter active releases only
              </mat-checkbox>
              <mat-checkbox formControlName="filterByLatestIfcFiles" matTooltip="Only return tags for the latest version of IFC files.">
                Filter by latest IFC files only
              </mat-checkbox>
            </div>
            <mat-checkbox formControlName="useIfcTags" matTooltip="Return tags from IFC files instead of builder specified tags.">
              Fill IFC tags instead of builder specified tags
            </mat-checkbox>
            <mat-checkbox formControlName="ifcTagsOnly" matTooltip="Only return tags that come from IFC files.">
              Fill IFC tags only
            </mat-checkbox>
            <mat-checkbox formControlName="standardTagsOnly" matTooltip="Only return standard tags (not tags from IFC files).">
              Fill standard tags only
            </mat-checkbox>
          </div>

          <small>Filter by Tag Types</small>
          <mat-form-field class="accent">
            <mat-select formControlName="includeTagGroups" multiple>
              <mat-option *ngFor="let tagGroups of getThemeReplacementTagGroups()" [value]="tagGroups">{{ tagGroups }}</mat-option>
            </mat-select>
          </mat-form-field>

          <small>Filter by Areas</small>
          <mat-chip-list>
            <mat-chip *ngFor="let area of (areaGroups | keyvalue)" selectable="true" (click)="toggleArea(area.value)">
              {{ area.key }}
            </mat-chip>
          </mat-chip-list>

          <small>Filter by Product Types</small>          
          <mat-form-field class="w-100">
            <mat-chip-list #chipList aria-label="Selected Product Types">
              <mat-chip
                *ngFor="let productTypeId of autoFillTagSearchForm.value.selectedProductTypes"
                [selectable]="true"
                [removable]="true"
                (removed)="onRemoveAutoFillTagProductType(productTypeId)">
                {{ getProductType(productTypeId)?.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                #productTypeInput
                [matAutocomplete]="autoFillTagProductTypeAuto"
                [formControl]="autoFillTagProductTypeControl"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="[13, 188]"
                [matChipInputAddOnBlur]="false"
              />
            </mat-chip-list>
            <mat-autocomplete #autoFillTagProductTypeAuto="matAutocomplete" (optionSelected)="onAutoFillTagProductTypeSelected($event.option.value)">
              <mat-option *ngFor="let productType of filteredAutoFillTagProductTypes | async" [value]="productType.id">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                  <div class="product-type-dropdown-indicator" [style.background-color]="productType?.color" matTooltip="Product Type"></div>
                  <span [innerHtml]="productType.name | encodeHtml | highlight: autoFillTagProductTypeControl.key"></span>
                </div>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          
          <div class="mt-2 w-100" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-raised-button color="primary" type="submit">Fill Tags</button>
            </div>
            
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
              <button mat-raised-button mat-flat-button type="button" (click)="clearHighlightedTags()">Clear Highlighted Tags</button>
              <button mat-raised-button mat-flat-button type="button" (click)="highlightObsoleteTags()">Highlight Obsolete Tags</button>
            </div>
          </div>
        </form>
      </div>

      <div class="w-100" *ngFor="let group of filteredGroupedLineItems">

        <ng-container [ngTemplateOutlet]="lineItem" [ngTemplateOutletContext]="{group:group, productId:getProductId(group)}"></ng-container>

      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #lineItem let-group='group' let-productId='productId'>
  <mat-expansion-panel [id]="group.id" [(expanded)]="group.isExpanded" [ngClass]="{'group-border': group.isSelected}" hideToggle>
    <mat-expansion-panel-header>
      
      <ng-container [ngTemplateOutlet]="lineItem_header" [ngTemplateOutletContext]="{group:group, isProduct:isAProduct(group), isRequestedProduct:isARequestedProduct(group), requestedProductCanBeUpgraded:requestedProductCanBeUpgraded(group)}"></ng-container>

    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent> <!-- Lazy Load the content -->
      
      <ng-container [ngTemplateOutlet]="lineItem_body" [ngTemplateOutletContext]="{group:group, productId:productId}"></ng-container>

    </ng-template>
  </mat-expansion-panel>
</ng-template>

<ng-template #lineItem_header let-group='group' let-isProduct='isProduct' let-isRequestedProduct='isRequestedProduct' let-requestedProductCanBeUpgraded="requestedProductCanBeUpgraded">
  <div class="w-100 faux-card">
    <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-sm="column" fxLayoutGap="10px">
      <div fxFlex="50" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

        <ng-container [ngTemplateOutlet]="product_thumbnail" [ngTemplateOutletContext]="{productPreview:getProductPreview(group), displayName:getProductName(group), isProduct:isProduct, isRequestedProduct:isRequestedProduct}"></ng-container>

        <div fxLayout="column" fxLayoutAlign="space-between start" >
          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="line-item-details">
            <small *ngIf="getLineItemTypeName(group.lineItemTypeId)" class="text-info" [innerHTML]="getLineItemTypeName(group.lineItemTypeId) | encodeHtml | highlight: themeLineItemFilterTerm"></small>
            <small *ngIf="!getLineItemTypeName(group.lineItemTypeId)" class="text-info"><i>No product type selected</i></small>
            <mat-icon *ngIf="group.isExpanded && group.lineItems.length > 0" (click)="duplicateLineItemTypeGroup(group); $event.stopPropagation();" matTooltip="Duplicate Group">control_point_duplicate</mat-icon>
            <mat-icon *ngIf="group.isExpanded && group.lineItems.length > 0" (click)="duplicateLineItemTypeGroup(group, true); $event.stopPropagation();" matTooltip="Duplicate Group with Tags">control_point</mat-icon>
            <mat-icon *ngIf="allowAlternativeLineItemTypesForGroup(group)" (click)="group.showLineItemTypeSwap = true; $event.stopPropagation();" matTooltip="Swap Type">swap_horiz</mat-icon>

            <div *ngIf="requestedProductCanBeUpgraded" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <mat-icon class="text-purple">upgrade</mat-icon>
              <small class="text-purple">Product Update Available</small>
            </div>

            <div *ngIf="productIsDisabled(group); else checkProductGroupIsNotLive" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <mat-icon class="text-warning">disabled_by_default</mat-icon>
              <small class="text-warning">Product Is Disabled</small>
            </div>

            <ng-template #checkProductGroupIsNotLive>
              <div *ngIf="productIsNotLive(group); else checkProductGroupHasDisabledCallout" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <product-workflow-icon
                  [workflowStateType]="productWorkflowState(group)">
                </product-workflow-icon>
                <small class="text-info">Product Is Not Live</small>
              </div>
            </ng-template>

            <ng-template #checkProductGroupHasDisabledCallout>
              <div *ngIf="productCalloutIsDisabled(group)" matTooltip="Product Callouts Are Turned Off">
                <mat-icon class="text-blue">preview_off</mat-icon>
              </div>
            </ng-template>

          </div>
          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="line-item-details">
            <ng-container [ngTemplateOutlet]="product_name" [ngTemplateOutletContext]="{group:group}"></ng-container>
          </div>
        </div>
      </div>
      <div fxFlex="50" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="5px">

        <mat-chip-list *ngIf="!group.isExpanded" fxFlex="50" fxLayoutAlign="start center" fxLayout="row">
          <ng-container *ngFor="let tag of group.getDisplayTags(); let i = index">
            <mat-chip class="green-chip" *ngIf="i < 3">
              <div class="green-chip-label" fxLayoutGap="3px">
                <small *ngIf="isBuilderIfcTag(tag)">({{getBuilderIfcSettingTag(tag)}})</small>
                <span [innerHTML]="tag | encodeHtml | highlight: themeLineItemFilterTerm"></span>
              </div>
            </mat-chip>
            <mat-chip class="green-chip" *ngIf="i === 3">+{{ group.getDisplayTags().length - 3 }}</mat-chip>
          </ng-container>
        </mat-chip-list>

        <mat-chip-list *ngIf="!group.isExpanded" fxFlex="50" fxLayoutAlign="start center" fxLayout="row">
          <ng-container *ngFor="let scope of group.getDisplayScopes(); let j = index">
            <mat-chip class="blue-chip" *ngIf="j < 3" [innerHTML]="scope.getName() | encodeHtml | highlight: themeLineItemFilterTerm"></mat-chip>
            <mat-chip class="blue-chip" *ngIf="j === 3">+{{ group.getDisplayScopes().length - 3 }}</mat-chip>
          </ng-container>
        </mat-chip-list>

        <button mat-icon-button color="accent" *ngIf="group.isExpanded" (click)="removeLineItemGroup(group)">
          <mat-icon>delete</mat-icon>
        </button>

      </div>
    </div>
  </div>
</ng-template>

<ng-template #lineItem_body let-group='group' let-productId='productId'>
  <div fxLayout="row" fxLayoutAlign="space-between stretch" >
  
    <div class="group-selector"  [ngClass]="{'group-selector-selected': group.isSelected}" fxLayout="column" fxLayoutAlign="start center" >
      <mat-icon *ngIf="group.isSelected" (click)="group.isSelected = false">check_box</mat-icon>
      <mat-icon *ngIf="!group.isSelected" (click)="group.isSelected = true">check_box_outline_blank</mat-icon>
    </div>

    <div class="group-details" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
      
      <form *ngIf="!group.showLineItemTypeSwap" fxFlex="50" fxLayout="row wrap" fxLayoutAlign="space-between space-between">
        <ng-container *ngFor="let templateProperty of getLineItemTypeProperties(group.lineItemTypeId)">
          
          <ng-container [ngTemplateOutlet]="lineItemProperty" [ngTemplateOutletContext]="{group:group, templateProperty:templateProperty}"></ng-container>

        </ng-container>
      </form>

      <div *ngIf="group.showLineItemTypeSwap" fxFlex="50" fxLayout="row" fxLayoutGap="5px">
        
        <mat-form-field> 
          <mat-label>Alternative Line Item Type</mat-label>
          <mat-select [(ngModel)]="group.lineItemTypeId" (selectionChange)="onLineItemTypeChange(group); debounceSaveChanges();">
            <mat-option *ngFor="let lineItemType of getAlternativeLineItemTypesForGroup(group)" [value]="lineItemType.id">
              {{ lineItemType.name }}
            </mat-option>
          </mat-select>
        </mat-form-field> 

        <button mat-icon-button *ngIf="group.isExpanded && group.showLineItemTypeSwap" (click)="group.showLineItemTypeSwap = false">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>

      <div fxFlex="50" fxLayout="row" fxLayoutGap="5px">
        
        <div *ngIf="!group.tagToEdit" fxFlex="50" fxLayout="column" fxLayoutAlign="start center">
          <mat-expansion-panel *ngIf="group.isExpanded" [(expanded)]="group.showTagSelection" (opened)="getTagOptions(group)" class="w-100">
            <mat-expansion-panel-header>
              <mat-chip-list class="w-100">
                <mat-chip *ngFor="let tag of group.getDisplayTags()" class="green-chip" [ngClass]="{'tag-highlight': group.tagsToHighlight.has(tag)}" (click)="$event.stopPropagation();">
                  <div class="green-chip-label" fxLayoutGap="3px">
                    <small *ngIf="isBuilderIfcTag(tag)">({{getBuilderIfcSettingTag(tag)}})</small>
                    <span [innerHTML]="tag | encodeHtml | highlight: themeLineItemFilterTerm"></span>
                  </div>
                  <button matChipRemove *ngIf="hasBuilderIfcTag(tag)" (click)="group.showTagEdit(tag)" matTooltip="Edit Tag">
                    <mat-icon style="color: #000">edit</mat-icon>
                  </button>
                  <button matChipRemove (click)="removeTagFromGroup(group, tag)" matTooltip="Remove Tag">
                    <mat-icon style="color: #000">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="!group.showTagSelection" class="green-chip" matTooltip="Show Unused Tags">
                  <mat-icon>add</mat-icon>
                </mat-chip>
                <mat-chip *ngIf="group.showTagSelection" class="green-chip" matTooltip="Hide Unused Tags">
                  <mat-icon>remove</mat-icon>
                </mat-chip>
              </mat-chip-list>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent> <!-- Lazy Load the content -->
              <span *ngIf="!group.allValidTags">Loading</span>
              <div class="chip-add-list">

                <mat-form-field class="accent">
                  <mat-label>Filter Tags</mat-label>
                  <input matInput type="text" name="tagSearchTerm"
                      [(ngModel)]="group.tagSearchTerm"
                      (ngModelChange)="group.filterTags()">
                  <button mat-button *ngIf="group.tagSearchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="group.tagSearchTerm=''; group.filterTags()">
                      <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>

                <mat-chip-list class="w-100">
                    <mat-chip *ngFor="let tag of group.filteredTags" (click)="onTagSelected(group, tag)" [innerHtml]="tag.tag | encodeHtml | highlight: group.tagSearchTerm">
                    </mat-chip> 
                </mat-chip-list>

                <div *ngIf="group.remainingFilteredTags.length > 0" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px" class="w-100">
                  <button mat-button (click)="group.toggleRemainingTags()">
                    <mat-icon *ngIf="!group.showRemainingTags">arrow_right</mat-icon>
                    <mat-icon *ngIf="group.showRemainingTags">arrow_drop_down</mat-icon>
                    Show All Tags
                  </button>

                  <mat-chip-list *ngIf="group.showRemainingTags" class="w-100">
                      <mat-chip *ngFor="let tag of group.remainingFilteredTags" (click)="onTagSelected(group, tag)" [innerHtml]="tag.tag | encodeHtml | highlight: group.tagSearchTerm">
                      </mat-chip> 
                  </mat-chip-list>
                </div>

              </div>
            </ng-template>
          </mat-expansion-panel>
        </div>

        <div *ngIf="group.tagToEdit" fxFlex="50" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
          <mat-chip class="green-chip">
            <div class="green-chip-label" fxLayoutGap="3px">
              <small *ngIf="isBuilderIfcTag(group.tagToEdit)">({{getBuilderIfcSettingTag(group.tagToEdit)}})</small>
              <span>{{ group.tagToEdit }}</span>
            </div>
            <button matChipRemove (click)="group.showTagEdit(); debounceSaveChanges();" matTooltip="Save Tag">
              <mat-icon style="color: #000">save</mat-icon>
            </button>
            <button matChipRemove (click)="group.cancelTagEdit()" matTooltip="Remove Tag">
              <mat-icon style="color: #000">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-radio-group fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="3px" >
            <mat-radio-button *ngFor="let ifcTag of getIfcTags(group.tagToEdit)"
              [value]="ifcTag"
              [checked]="ifcTag == group.tagToEdit"
              (click)="group.editTag(group.tagToEdit, ifcTag)">
              {{ ifcTag }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div *ngIf="!group.scopeToEdit" fxFlex="50" fxLayout="column" fxLayoutAlign="start center">
          <mat-expansion-panel *ngIf="group.isExpanded" [(expanded)]="group.showScopeSelection" (opened)="group.filterScopes()" class="w-100 m-4">
            <mat-expansion-panel-header>
              <mat-chip-list class="w-100">
                <ng-container *ngFor="let scope of group.getDisplayScopes(true)">
                  <mat-chip class="blue-chip" [ngClass]="{'scope-highlight': group.scopesToHighlight.has(scope.getName())}" (click)="$event.stopPropagation();">
                    <span [innerHTML]="scope.getName() | encodeHtml | highlight: themeLineItemFilterTerm"></span>
                    <button matChipRemove (click)="group.showScopeEdit(scope)" matTooltip="Edit Scopes">
                      <mat-icon style="color: #000">edit</mat-icon>
                    </button>
                    <button matChipRemove (click)="removeScopeFromGroup(group, scope.scope, scope.scopeVariant)" matTooltip="Remove Scopes">
                      <mat-icon style="color: #000">clear</mat-icon>
                    </button>
                  </mat-chip>
                </ng-container>
                <mat-chip *ngIf="!group.showScopeSelection" class="blue-chip" matTooltip="Show Unused Scopes">
                  <mat-icon>add</mat-icon>
                </mat-chip>
                <mat-chip *ngIf="group.showScopeSelection" class="blue-chip" matTooltip="Hide Unused Scopes">
                  <mat-icon>remove</mat-icon>
                </mat-chip>
              </mat-chip-list>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent> <!-- Lazy Load the content -->
              <div class="chip-add-list">

                <mat-form-field class="accent">
                  <mat-label>Filter Scopes</mat-label>
                  <input matInput type="text" name="scopeSearchTerm"
                      [(ngModel)]="group.scopeSearchTerm"
                      (ngModelChange)="group.filterScopes()">
                  <button mat-button *ngIf="group.scopeSearchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="group.scopeSearchTerm=''; group.filterScopes()">
                      <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>

                <mat-chip-list class="w-100">
                    <mat-chip *ngFor="let scope of group.filteredScopes" (click)="onScopeSelected(group, scope)" [innerHtml]="scopes[scope] | encodeHtml | highlight: group.scopeSearchTerm">
                    </mat-chip>
                </mat-chip-list>

              </div>
            </ng-template>
          </mat-expansion-panel>
        </div>

        <div *ngIf="group.scopeToEdit" fxFlex="50" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
          <mat-chip class="blue-chip">
            {{ group.scopeToEdit.getName() }}
            <button matChipRemove (click)="group.showScopeEdit(); debounceSaveChanges();" matTooltip="Save Scope">
              <mat-icon style="color: #000">save</mat-icon>
            </button>
          </mat-chip>
          <mat-radio-group fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="3px" >
            <mat-radio-button *ngFor="let scopeVariant of group.scopeToEdit.getScopeVariants()"
              [value]="scopeVariant"
              [checked]="scopeVariant == group.scopeToEdit.scopeVariant"
              (click)="group.editScopeVariant(scopeVariant)">
              {{ scopeVariants[scopeVariant] }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

      </div>
    </div>
    
  </div>
</ng-template>

<ng-template #lineItemProperty let-group='group' let-templateProperty='templateProperty'>

  <div [fxFlex]="templateProperty.assetType === propertyTypes.TEMPLATE ? 100 : 49">
    <ng-container [ngSwitch]="templateProperty.assetType">

      <ng-container *ngSwitchCase="propertyTypes.TEMPLATE">
        <ng-container [ngTemplateOutlet]="property_template" [ngTemplateOutletContext]="{group:group, property:group.lineItemProperties[templateProperty.propertyName], templateProperty:templateProperty, isProduct:isAProduct(group, templateProperty.propertyName), isRequestedProduct:isARequestedProduct(group, templateProperty.propertyName), requestedProductCanBeUpgraded:requestedProductCanBeUpgraded(group, templateProperty.propertyName)}"></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="propertyTypes.STRING">
        <ng-container [ngTemplateOutlet]="property_string" [ngTemplateOutletContext]="{property:group.lineItemProperties[templateProperty.propertyName], templateProperty:templateProperty}"></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="propertyTypes.INT">
        <ng-container [ngTemplateOutlet]="property_number" [ngTemplateOutletContext]="{property:group.lineItemProperties[templateProperty.propertyName], templateProperty:templateProperty}"></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="propertyTypes.FLOAT">
        <ng-container [ngTemplateOutlet]="property_number" [ngTemplateOutletContext]="{property:group.lineItemProperties[templateProperty.propertyName], templateProperty:templateProperty}"></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="propertyTypes.BOOL">
        <ng-container [ngTemplateOutlet]="property_bool" [ngTemplateOutletContext]="{property:group.lineItemProperties[templateProperty.propertyName], templateProperty:templateProperty}"></ng-container>
      </ng-container>
      
      <ng-container *ngSwitchCase="propertyTypes.ENUM">
        <ng-container [ngTemplateOutlet]="property_enum" [ngTemplateOutletContext]="{property:group.lineItemProperties[templateProperty.propertyName], templateProperty:templateProperty}"></ng-container>
      </ng-container>

    </ng-container>
  </div>

</ng-template>

<ng-template #property_template let-group='group' let-property='property' let-templateProperty='templateProperty' let-isProduct='isProduct' let-isRequestedProduct='isRequestedProduct' let-requestedProductCanBeUpgraded='requestedProductCanBeUpgraded'>
  <small class="text-info">{{ templateProperty.propertyName }}</small>
  <div class="m-b-10 link" (click)="addProduct(group, templateProperty.propertyName, false, templateProperty.templateName)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    
    <ng-container [ngTemplateOutlet]="product_thumbnail" [ngTemplateOutletContext]="{productPreview:getProductPreview(group, templateProperty.propertyName), displayName:getProductName(group, templateProperty.propertyName), isProduct:isProduct, isRequestedProduct:isRequestedProduct}"></ng-container>

    <div fxLayout="column" fxLayoutAlign="space-between start" >
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="line-item-details">

        <ng-container *ngIf="isProduct; else checkIsRequestedProductType" >
          <small class="text-info" [innerHTML]="getProductTypeName(group, templateProperty.propertyName) | encodeHtml | highlight: themeLineItemFilterTerm"></small>
          
          <div *ngIf="productIsDisabled(group, templateProperty.propertyName); else checkProductIsNotLive" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"> 
            <mat-icon class="text-warning">disabled_by_default</mat-icon>
            <small class="text-warning">Product Is Disabled</small>
          </div>
          
          <ng-template #checkProductIsNotLive>
            <div *ngIf="productIsNotLive(group, templateProperty.propertyName); else checkProductGroupHasDisabledCallout" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"> 
              <product-workflow-icon
                [workflowStateType]="productWorkflowState(group, templateProperty.propertyName)">
              </product-workflow-icon>
              <small class="text-info">Product Is Not Live</small>
            </div>
          </ng-template>

          <ng-template #checkProductGroupHasDisabledCallout>
            <div *ngIf="productCalloutIsDisabled(group, templateProperty.propertyName)" matTooltip="Product Callouts Are Turned Off">
              <mat-icon class="text-blue">preview_off</mat-icon>
            </div>
          </ng-template>
        </ng-container>

        <ng-template #checkIsRequestedProductType>
          <ng-container *ngIf="isRequestedProduct; else emptyProductTypeName" >
            <small class="text-info" [innerHTML]="getRequestedProductTypeName(group, templateProperty.propertyName) | encodeHtml | highlight: themeLineItemFilterTerm"></small>
            <small class="text-purple">(Requested Product)</small>
          </ng-container> 
        </ng-template>

        <ng-template #emptyProductTypeName>
          <small></small>
        </ng-template>

      </div>
      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="line-item-details">

        <ng-container [ngTemplateOutlet]="product_name" [ngTemplateOutletContext]="{group:group, propertyName:templateProperty.propertyName}"></ng-container>

        <mat-icon matTooltip="Swap product">swap_horiz</mat-icon>
        <a *ngIf="isProduct" routerLink="/products/{{ getProductId(group, templateProperty.propertyName) }}" target="_blank" (click)="$event.stopPropagation();" routerLinkActive="active">
          <mat-icon matTooltip="Edit product">edit</mat-icon>
        </a>
        <mat-icon *ngIf="requestedProductCanBeUpgraded" class="text-purple font-bold" (click)="updateRequestedProductToProduct(group, templateProperty.propertyName); $event.stopPropagation();" matTooltip="Update Requested Product to a Product">upgrade</mat-icon>
        <mat-icon *ngIf="isProduct || isRequestedProduct" (click)="deleteProduct(group, templateProperty.propertyName); $event.stopPropagation();" matTooltip="Delete Product">delete</mat-icon>
      </div>
    </div>

  </div>
</ng-template>

<ng-template #property_string let-property='property' let-templateProperty='templateProperty'>
  <mat-form-field>
    <mat-label>{{ templateProperty.propertyName }}</mat-label>
    <input matInput [type]="text"
      [(ngModel)]="property.string"
      (ngModelChange)="debounceSaveChanges()"
      [required]="!templateProperty.isOptional"
      name="{{templateProperty.propertyName}}">
  </mat-form-field>
</ng-template>

<ng-template #property_number let-property='property' let-templateProperty='templateProperty'>
  <mat-form-field *ngIf="!templateProperty.range">
    <mat-label>{{ templateProperty.propertyName }}</mat-label>
    <input matInput [type]="number"
      [(ngModel)]="property.float"
      (ngModelChange)="debounceSaveChanges()"
      [required]="!templateProperty.isOptional"
      name="{{templateProperty.propertyName}}">
  </mat-form-field>
  <mat-form-field *ngIf="templateProperty.range">
    <mat-label>{{ templateProperty.propertyName }}</mat-label>
    <input matInput type="number"
      [(ngModel)]="property.float"
      (ngModelChange)="debounceSaveChanges()"
      [required]="!templateProperty.isOptional"
      name="{{templateProperty.propertyName}}"
      [min]="getRangeMin(templateProperty.range)" [max]="getRangeMax(templateProperty.range)">
  </mat-form-field>
</ng-template>

<ng-template #property_bool let-property='property' let-templateProperty='templateProperty'>
  <mat-checkbox
    [(ngModel)]="property.bool"
    (ngModelChange)="debounceSaveChanges()"
    [required]="!templateProperty.isOptional"
    name="{{templateProperty.propertyName}}">
    {{ templateProperty.propertyName }}
  </mat-checkbox>
</ng-template>

<ng-template #property_enum let-property='property' let-templateProperty='templateProperty'>
  <mat-form-field>
    <mat-label>{{ templateProperty.propertyName }}</mat-label>
    <mat-select [(ngModel)]="property.string"
      (ngModelChange)="debounceSaveChanges()"
      name="{{templateProperty.propertyName}}">
      <mat-option *ngFor="let value of templateProperty.enumValues.split(',')" [value]="value">{{ value }}</mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #product_name let-group='group' let-propertyName='propertyName'>
  <ng-container *ngIf="getProductName(group, propertyName); else checkRequestedProductId" >
    <img class="company-logo" *ngIf="getCompanyLogoByProduct(group, propertyName)" [src]="getCompanyLogoByProduct(group, propertyName)">
    <small *ngIf="!getCompanyLogoByProduct(group, propertyName)">{{ getCompanyNameByProduct(group, propertyName) }}</small>
    <span [innerHTML]="getProductName(group, propertyName) | encodeHtml | highlight: themeLineItemFilterTerm"></span>
    <small *ngIf="getProductSku(group, propertyName)">{{ getProductSku(group, propertyName) }}</small>
  </ng-container>

  <ng-template #checkRequestedProductId>
    <ng-container *ngIf="getRequestedProductName(group, propertyName); else checkProductId" >
      <img class="company-logo" *ngIf="getCompanyLogoByRequestedProduct(group, propertyName)" [src]="getCompanyLogoByRequestedProduct(group, propertyName)">
      <small *ngIf="!getCompanyLogoByRequestedProduct(group, propertyName)">{{ getCompanyNameByRequestedProduct(group, propertyName) }}</small>
      <span class="text-purple" [innerHTML]="getRequestedProductName(group, propertyName) | encodeHtml | highlight: themeLineItemFilterTerm"></span>
      <small *ngIf="getRequestedProductSku(group, propertyName)">{{ getRequestedProductSku(group, propertyName) }}</small>
    </ng-container>
  </ng-template>

  <ng-template #checkProductId>
    <ng-container *ngIf="getProductId(group, propertyName); else noProduct" >
      <i>Could not load Product</i>
      <mat-icon *ngIf="!getLineItemType(group.lineItemTypeId)" matTooltip="Add product" (click)="addProduct(group, propertyName, false, undefined); $event.stopPropagation();">add</mat-icon>
    </ng-container>
  </ng-template>

  <ng-template #noProduct>
    <i>No product selected</i>
    <mat-icon *ngIf="!getLineItemType(group.lineItemTypeId)" matTooltip="Add product" (click)="addProduct(group, propertyName, false, undefined); $event.stopPropagation();">add</mat-icon>
  </ng-template>
</ng-template>

<ng-template #product_thumbnail let-productPreview='productPreview' let-displayName='displayName' let-isProduct='isProduct' let-isRequestedProduct='isRequestedProduct'>
  <div class="thumbnail-container">
    <ng-container *ngIf="isProduct && productPreview; else checkIsRequestedProduct" >
      <img src="/assets/images/no-image-icon.svg" lazyLoad="{{SituViewUrl}}/home/getimage?artifactid={{productPreview}}&filename=thumbnail.webp" class="thumbnail">
      <mat-icon class="view-3d-button link" (click)="onView3dPreview(productPreview, displayName); $event.stopPropagation();" color="accent">view_in_ar</mat-icon>
    </ng-container>

    <ng-template #checkIsRequestedProduct>
      <div *ngIf="isRequestedProduct; else showNoImageIcon" class="thumbnail" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon class="requested-product-icon">kitchen</mat-icon>
        <mat-icon class="overlay-requested-product-icon text-purple">pending</mat-icon>
      </div>
    </ng-template>

    <ng-template #showNoImageIcon>
      <img src="/assets/images/no-image-icon.svg" class="thumbnail">
    </ng-template>
  </div>
</ng-template>
